<div class="statEventsPage">
  <div class="toolbar">
    <app-date-interval-selector
      [initialFromDate]="initialFromDate"
      [initialToDate]="initialToDate"
      (changeDate)="applyDateFilter($event)"
    ></app-date-interval-selector>
    <div class="spacer"></div>
    <button mat-flat-button color="warn" *ngIf="isFiltered" (click)="clearFilters()" matTooltip="{{ 'itemFilter.clearAll' | translate }}">
      <img class="custom-icon" src="assets/images/custom-icon/clear-filter.png" />
    </button>
    <button mat-stroked-button *ngIf="!isFiltered" (click)="clearFilters()" matTooltip="{{ 'itemFilter.clearAll' | translate }}">
      <img class="custom-icon" src="assets/images/custom-icon/clear-filter.png" />
    </button>
  </div>
  <app-filters-display [filters]="filtersWithoutDate" (removeFilter)="applyFilters($event)"> </app-filters-display>
  <div class="statEvents">
    <table
      mat-table
      [dataSource]="eventsDataSource"
      class="full-width-table mat-elevation-z1"
      matSort
      matSortActive="eventDatetime"
      matSortDirection="desc"
      [ngStyle]="(eventsDataSource.loading$ | async) || isLoading ? { display: 'none' } : {}"
    >
      <ng-container matColumnDef="eventDatetime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "page.statEvents.eventDatetime" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.eventDatetime | safeDate : "YYYY-MM-dd HH:mm" }}</td>
      </ng-container>

      <ng-container matColumnDef="eventSource">
        <th mat-header-cell *matHeaderCellDef>
          {{ "page.statEvents.eventSource" | translate }}
          <app-item-filter
            fieldName="{{ 'page.statEvents.eventSource' | translate }}"
            propertyName="eventSource"
            [dataType]="dataTypeChoice"
            [data]="true"
            [defaultValue]="activeFilters | filterFor : 'eventSource'"
            translatePrefix="page.statEvents"
            [translateFieldKey]="'page.statEvents.eventSource'"
            (applyFilter)="applyFilters($event)"
          >
          </app-item-filter>
        </th>
        <td mat-cell *matCellDef="let element">{{ "page.statEvents." + element.eventSource | translate }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "page.statEvents.description" | translate }}
          <app-item-filter
            fieldName="{{ 'page.statEvents.description' | translate }}"
            propertyName="description"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'description'"
            [translateFieldKey]="'page.statEvents.description'"
            (applyFilter)="applyFilters($event)"
          >
          </app-item-filter>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.description }}</td>
      </ng-container>

      <ng-container matColumnDef="careplans">
        <th mat-header-cell *matHeaderCellDef>
          {{ "page.statEvents.careplans" | translate }}
          <app-item-filter
            fieldName="{{ 'page.statEvents.careplans' | translate }}"
            propertyName="careplans"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'careplans'"
            [translateFieldKey]="'page.statEvents.careplans'"
            (applyFilter)="applyFilters($event)"
          >
          </app-item-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngFor="let careplan of element.careplans; let i = index">
            {{ careplan.description }}<span *ngIf="i < element.careplans.length - 1"><br /> </span>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "page.statEvents.userName" | translate }}
          <app-item-filter
            fieldName="{{ 'page.statEvents.userName' | translate }}"
            propertyName="userName"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'userName'"
            [translateFieldKey]="'page.statEvents.userName'"
            (applyFilter)="applyFilters($event)"
          >
          </app-item-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.userName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="services">
        <th mat-header-cell *matHeaderCellDef>
          {{ "page.statEvents.services" | translate }}
          <app-item-filter
            fieldName="{{ 'page.statEvents.services' | translate }}"
            propertyName="serviceName"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'serviceName'"
            [translateFieldKey]="'page.statEvents.services'"
            (applyFilter)="applyFilters($event)"
          >
          </app-item-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngFor="let service of element.services; let i = index">
            {{ service.serviceName }}<span *ngIf="i < element.services.length - 1"><br /></span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="patientName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "page.statEvents.patientName" | translate }}
          <app-item-filter
            fieldName="{{ 'page.statEvents.patientName' | translate }}"
            propertyName="patientName"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'patientName'"
            [translateFieldKey]="'page.statEvents.patientName'"
            (applyFilter)="applyFilters($event)"
          >
          </app-item-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.patientName }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <div class="spinner-container" *ngIf="(eventsDataSource.loading$ | async) || isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <mat-paginator
      #paginator
      pageIndex="0"
      [length]="eventsCount"
      [pageSize]="currentPageSize"
      [pageSizeOptions]="[25, 50, 100, 250]"
      [ngStyle]="(eventsDataSource.loading$ | async) || isLoading ? { display: 'none' } : {}"
    ></mat-paginator>
  </div>
</div>
